var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -3.5 24 24",
    id: "meteor-icon-kit__regular-forward",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5858 6H10C5.58172 6 2 9.5817 2 14V16.0312C2 16.5835 1.55228 17.0312 1 17.0312C0.447715 17.0312 0 16.5835 0 16.0312V14C0 8.4772 4.47715 4 10 4H15.5858L13.2929 1.70711C12.9024 1.31658 12.9024 0.68342 13.2929 0.29289C13.6834 -0.09763 14.3166 -0.09763 14.7071 0.29289L18.7071 4.29289C19.0976 4.68342 19.0976 5.31658 18.7071 5.70711L14.7071 9.7071C14.3166 10.0976 13.6834 10.0976 13.2929 9.7071C12.9024 9.3166 12.9024 8.6834 13.2929 8.2929L15.5858 6zM21.5858 5L18.2929 1.70711C17.9024 1.31658 17.9024 0.68342 18.2929 0.29289C18.6834 -0.09763 19.3166 -0.09763 19.7071 0.29289L23.7071 4.29289C24.0976 4.68342 24.0976 5.31658 23.7071 5.70711L19.7071 9.7071C19.3166 10.0976 18.6834 10.0976 18.2929 9.7071C17.9024 9.3166 17.9024 8.6834 18.2929 8.2929L21.5858 5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.c8183d6ea88b0d17ffa50edd3adb31f4.svg";
export { ForwardRef as ReactComponent };